import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Directive({
  selector: "[appScrollable]",
  exportAs: "appScrollable",
})
export class ScrollDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef) {}

  @Input() scrollUnit: number;
  @Output() isOverflowChange = new EventEmitter<boolean>();

  ngAfterViewInit() {
    this.checkOverflow();
  }

  @HostListener("window:resize")
  onResize() {
    this.checkOverflow();
  }

  private checkOverflow() {
    const isOverflow = this.element.scrollWidth > this.element.clientWidth;
    this.isOverflowChange.emit(isOverflow);
  }

  private get element() {
    return this.elementRef.nativeElement;
  }

  get isOverflow() {
    return this.element.scrollWidth > this.element.clientWidth;
  }

  scroll(direction: number) {
    this.element.scrollLeft += this.scrollUnit * direction;
  }

  get canScrollStart() {
    return this.element.scrollLeft > 0;
  }

  get canScrollEnd() {
    return (
      this.element.scrollLeft + this.element.clientWidth !=
      this.element.scrollWidth
    );
  }
}
